import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../Library/BaseComponent';
import { MasterDataService } from '../../Services/MasterDataService';
import { NgbModal, NgbActiveModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ChangePasswordRequest } from '../../Models/RequestModels';
import { UserService } from '../../Services/UserService';

@Component({
    selector: 'ChangePassword',
    templateUrl: './ChangePassword.html',
})

export class ChangePassword extends BaseComponent implements OnInit {
    @ViewChild('content') content;
    ModalRef: NgbModalRef;
    Model: any;
    DisableModalOpenEvent: boolean = false;

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, public modalService: NgbModal, protected userService: UserService) {
        super(translate, toastr, route, router, masterService);

    }
    ngOnInit(): void {
    }

    Open(): void {
        if (this.DisableModalOpenEvent) return;
        this.Model = {};
        this.ClearErrors();
        let ngbModalOptions: NgbModalOptions = {
            backdrop : 'static',
            centered: true
        };
        this.ModalRef = this.modalService.open(this.content, ngbModalOptions);
        this.DisableModalOpenEvent = true;
        this.ModalRef.result.then((result) => {
        }, (reason) => {
            this.DisableModalOpenEvent = false;
        });
    }

    OnSubmit(): void {
       
        if (this.Validated()) {
            let req = new ChangePasswordRequest();
            req.NewPassword = this.Model.NewPassword;
            req.OldPassword = this.Model.OldPassword;
            this.userService.ChangePassword(req).then(data => {
                if (data.HasError) {
                    this.GetMultilingualToast(data.Errors[0].ErrorMessage, 'error');
                }
                else {
                    this.ModalRef.close();
                    this.GetMultilingualToast('TS.TS_PWD_CHANGED_SUCCESS', 'success');
                }
            })       
        }
    }

    Validated(): boolean {
        this.ClearErrors();
        if (this.Model.NewPassword)
            this.Model.NewPassword = this.Model.NewPassword.trim();
        if(this.Model.OldPassword)
            this.Model.OldPassword = this.Model.OldPassword.trim();
        if(this.Model.ConfirmPassword)
            this.Model.ConfirmPassword = this.Model.ConfirmPassword.trim();

        if (!this.Model.OldPassword || this.Model.OldPassword == '') {
            this.AddError('ERR.ERR_ENTER_OLD_PASSWORD');
            return false;
        }
        if (!this.Model.NewPassword || this.Model.NewPassword == '') {
            this.AddError('ERR.ERR_ENTER_NEW_PASSWORD');
            return false;
        }
        //if (this.Model.NewPassword && this.Model.NewPassword.length < 6) {
        //    this.AddError('ERR.ERR_PASSWORD_MIN_LENGTH_6');
        //    return false;
        //}
        if (!this.Model.ConfirmPassword || this.Model.ConfirmPassword == '') {
            this.AddError('ERR.ERR_CONFIRM_NEW_PASSWORD');
            return false;
        }
        if (this.Model.NewPassword != this.Model.ConfirmPassword) {
            this.AddError('ERR.ERR_CONFIRM_NOT_MATCH_NEW_PASSWORD');
            return false;
        }
        return true;
    }
}
